module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page single-product-page mx-5"
  }, [(_vm.isPageReady) ? _c('content-top-header', {
    staticClass: "black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', [_c('a', {
    attrs: {
      "href": "/product"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_vm._v("\n              < Back\n            ")])])])])], 2) : _vm._e(), _vm._v(" "), (_vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [_c('v-container', {
    staticClass: "ml-0 pl-0",
    attrs: {
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-start": "",
      "margin-top-header": ""
    }
  }, [_c('v-flex', {
    staticClass: "wrapFlex product-covers",
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('div', {
    staticClass: "product-container"
  }, [(!_vm.onMobile) ? _c('div', {
    staticClass: "product-side-thumbnails"
  }, _vm._l((_vm.covers), function(img, i) {
    return _c('div', {
      key: i,
      staticClass: "product-thumbnail",
      class: img === _vm.selectedCover ? 'selected' : '',
      on: {
        "click": function($event) {
          _vm.changeFeaturedImage(img)
        }
      }
    }, [_c('div', {
      staticClass: "product-covers",
      style: ({
        'background-image': ("url(" + img + ")"),
      })
    })])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product-cover-selected"
  }, [_c('div', {
    staticClass: "__selected",
    style: ({
      'background-image': ("url(" + _vm.selectedCover + ")"),
    })
  })])])]), _vm._v(" "), (_vm.product) ? _c('v-flex', {
    staticClass: "product-details",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "product-section pl-3"
  }, [_c('div', {
    staticClass: "product-category"
  }, [_vm._v(_vm._s(_vm.productCategoryName))]), _vm._v(" "), _c('div', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), _c('div', {
    staticClass: "product-price"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.product.price * 100)))]), _vm._v(" "), _c('div', {
    staticClass: "product-options"
  }, [_c('v-select', {
    staticClass: "large",
    attrs: {
      "items": _vm.options,
      "item-text": "name",
      "placeholder": "Select option",
      "item-value": "id",
      "single-line": "",
      "bottom": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.option),
      callback: function($$v) {
        _vm.option = $$v
      },
      expression: "option"
    }
  })], 1), _vm._v(" "), (_vm.isAuthenticated) ? _c('v-btn', {
    staticClass: "product-addTobag",
    attrs: {
      "round": "",
      "block": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.product.stock > 0 ? _vm.addToCart() : ''
      }
    }
  }, [(_vm.product.stock > -1) ? _c('span', [_vm._v("Add to cart")]) : _c('span', [_vm._v("Out of Stock")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "divider-x  mt-5 mb-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "product-merchant"
  }, [_c('user-tag', {
    staticClass: "tag",
    attrs: {
      "showAvatar": "",
      "user": _vm.product.merchant
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "divider-x  mt-3 mb-4"
  }), _vm._v(" "), (_vm.isAuthenticated) ? _c('div', {
    staticClass: "product-actions"
  }, [_c('user-follow-btn', {
    staticClass: "follow-btx",
    attrs: {
      "user": _vm.user,
      "theme": "blue",
      "type": "product",
      "borderRadius": "",
      "btnBlock": ""
    },
    on: {
      "afterFollow": _vm.afterFollow
    }
  }), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('span', {
    staticClass: "__actions pl-0",
    attrs: {
      "slot": "activator"
    },
    on: {
      "click": function($event) {
        _vm.addToCollections()
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "cursor-pointer mt-3 filter-invert",
    attrs: {
      "src": require("../../assets/plus.svg"),
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Add to wishlist")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('span', {
    staticClass: "__actions pl-0",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "cursor-pointer mt-3",
    attrs: {
      "src": "/static/images/ic_share.svg",
      "width": "20"
    },
    on: {
      "click": function($event) {
        _vm.share_dialog = true
      }
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Share")])])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "divider-x my-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "dflex w-100"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('div', {
    staticClass: "general-heading mb-4"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "product-description"
  }, [_vm._v("\n                " + _vm._s(_vm.product.description) + "\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "pl-3"
  }, [_c('div', {
    staticClass: "general-heading mb-4"
  }, [_vm._v("Info")]), _vm._v(" "), _c('div', {
    staticClass: "info-link-container"
  }, [_c('div', {
    staticClass: "info-modal-links dflex align-center gap-15",
    on: {
      "click": function($event) {
        (_vm.info_dialog = true) && (_vm.info_active_tab = 1)
      }
    }
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/link-icon.svg"),
      "width": "16"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-link-text"
  }, [_vm._v("\n                      Size & Fit\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-modal-links dflex align-center gap-15",
    on: {
      "click": function($event) {
        (_vm.info_dialog = true) && (_vm.info_active_tab = 2)
      }
    }
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/link-icon.svg"),
      "width": "16"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-link-text"
  }, [_vm._v("\n                      Shipping Policy\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-modal-links dflex align-center gap-15",
    on: {
      "click": function($event) {
        (_vm.info_dialog = true) && (_vm.info_active_tab = 3)
      }
    }
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/link-icon.svg"),
      "width": "16"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-link-text"
  }, [_vm._v("\n                      Return Policy\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-modal-links dflex align-center gap-15",
    on: {
      "click": function($event) {
        (_vm.info_dialog = true) && (_vm.info_active_tab = 4)
      }
    }
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/link-icon.svg"),
      "width": "16"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-link-text"
  }, [_vm._v("\n                      Privacy Policy\n                    ")])])])])]), _vm._v("''\n          ")], 1), _vm._v(" "), _c('div', {
    staticClass: "divider-x my-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "general-heading mb-4"
  }, [_vm._v("More from this seller")]), _vm._v(" "), _c('div', {}, [_c('v-layout', {
    staticClass: "covers-content"
  }, _vm._l((_vm.products), function(product, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "card-container",
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('product-card', {
      attrs: {
        "dataObject": product,
        "showFullOverlay": ""
      }
    })], 1)
  }))], 1)])], 1), _vm._v(" "), (_vm.isAuthenticated) ? _c('div', {
    staticClass: "flex-center py-5"
  }, [_c('comments', {
    staticClass: "w-80",
    attrs: {
      "item": _vm.product,
      "comments": _vm.comments,
      "commentTableType": _vm.commentTableType
    },
    on: {
      "reRenderComments": _vm.reRenderComments
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "info-dialog"
    },
    model: {
      value: (_vm.info_dialog),
      callback: function($$v) {
        _vm.info_dialog = $$v
      },
      expression: "info_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "general-heading w-100 mb-2"
  }, [_vm._v("\n              Info\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "dflex align-center gap-20"
  }, [_c('div', {
    staticClass: "modal-head",
    class: (_vm.info_active_tab == 1) ? "active" : null,
    on: {
      "click": function($event) {
        (_vm.info_active_tab = 1)
      }
    }
  }, [_vm._v("Size & Fit")]), _vm._v(" "), _c('div', {
    staticClass: "modal-head",
    class: (_vm.info_active_tab == 2) ? "active" : null,
    on: {
      "click": function($event) {
        (_vm.info_active_tab = 2)
      }
    }
  }, [_vm._v("Shipping policy")]), _vm._v(" "), _c('div', {
    staticClass: "modal-head",
    class: (_vm.info_active_tab == 3) ? "active" : null,
    on: {
      "click": function($event) {
        (_vm.info_active_tab = 3)
      }
    }
  }, [_vm._v("Return policy")]), _vm._v(" "), _c('div', {
    staticClass: "modal-head",
    class: (_vm.info_active_tab == 4) ? "active" : null,
    on: {
      "click": function($event) {
        (_vm.info_active_tab = 4)
      }
    }
  }, [_vm._v("Privacy policy")])])]), _vm._v(" "), _c('v-card-text', [_c('div', [((_vm.info_active_tab == 1)) ? _c('div', {
    staticClass: "modal-body-text"
  }, [_vm._v("\n                Size and fit\n              ")]) : _vm._e(), _vm._v(" "), ((_vm.info_active_tab == 2)) ? _c('div', {
    staticClass: "modal-body-text"
  }, [_vm._v("\n                Shipping policy\n              ")]) : _vm._e(), _vm._v(" "), ((_vm.info_active_tab == 3)) ? _c('div', {
    staticClass: "modal-body-text"
  }, [_vm._v("\n                Return policy\n              ")]) : _vm._e(), _vm._v(" "), ((_vm.info_active_tab == 4)) ? _c('div', {
    staticClass: "modal-body-text"
  }, [_vm._v("\n                Privacy policy\n              ")]) : _vm._e()])])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    staticStyle: {
      "margin-top": "3%"
    },
    attrs: {
      "content-class": ["finish-modal upload-finish-dialog"]
    },
    model: {
      value: (_vm.showReleaseProductModal),
      callback: function($$v) {
        _vm.showReleaseProductModal = $$v
      },
      expression: "showReleaseProductModal"
    }
  }, [(_vm.showReleaseProductModal) ? _c('album-finish-modal', {
    attrs: {
      "item": _vm.releaseProduct,
      "type": "product",
      "promote": _vm.showPromoteModal,
      "dismiss": _vm.dismissFinishDialog
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.share_dialog) ? _c('share-modal', {
    attrs: {
      "item": _vm.product,
      "dismiss": _vm.closeShareDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21f7bcfa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/sell/single_product.vue
// module id = 2149
// module chunks = 49